<template>
  <base-side-page
    @cancel="cancelSidePage"
    :title="$t('bill.product_type_maintenance')"
    icon="res-bill-product"
    :res-name="resName"
    :current-tab="params.windowData.currentTab"
    :loaded="loaded"
    :tabs="detailTabs"
    @tab-change="handleTabChange">
    <component :is="params.windowData.currentTab" id="BillProductList" :res-id="data.id" :data="detailData" cloud-env="mapping" />
  </base-side-page>
</template>

<script>
import SidePageMixin from '@/mixins/sidePage'
import WindowsMixin from '@/mixins/windows'
import Mapping from './Mapping.vue'
import ColumnsMixin from '../mixins/columns'

export default {
  name: 'BillProductSidePage',
  components: {
    Mapping,
  },
  mixins: [SidePageMixin, WindowsMixin, ColumnsMixin],
  data () {
    return {
    }
  },
  computed: {
    detailTabs () {
      return this.params.options.type === 'dictionary' ? [{ label: this.$t('bill.mapping'), key: 'mapping' }] : [{ label: this.$t('cloudenv.text_15'), key: 'event-drawer' }]
    },
    resName () {
      return this.params.options.type === 'dictionary' ? this.detailData.product_type : this.detailData.origin_res_type
    },
  },
  methods: {
  },
}
</script>
